module.exports = __webpack_public_path__ + "static/media/balance-board.178421df.jpg";